module.exports = __webpack_public_path__ + "img/logo-company_10.a2feddd2.png";